import { getSkeletonConfig } from 'common/dynamic-form/types/skeleton/skeleton.utils';

import { ISPConfigMappers } from './model/config-mapper.interface';

export const SKELETON_MAPPERS: ISPConfigMappers = {
  banner: getSkeletonConfig,
  button: getSkeletonConfig,
  captcha: getSkeletonConfig,
  select: getSkeletonConfig,
  autocomplete: getSkeletonConfig,
  switcher: getSkeletonConfig,
  switcherSelect: getSkeletonConfig,
  radio: getSkeletonConfig,
  radioimg: getSkeletonConfig,
  reflect: getSkeletonConfig,
  datetime: getSkeletonConfig,
  textarea: getSkeletonConfig,
  link: getSkeletonConfig,
  input: getSkeletonConfig,
  otp: getSkeletonConfig,
  checkbox: getSkeletonConfig,
  datepicker: getSkeletonConfig,
  colorpicker: getSkeletonConfig,
  file: getSkeletonConfig,
  password: getSkeletonConfig,
  promocode: getSkeletonConfig,
  phone: getSkeletonConfig,
  hidden: getSkeletonConfig,
  list: getSkeletonConfig,
  listfilter: getSkeletonConfig,
  textdata: getSkeletonConfig,
  totalsum: getSkeletonConfig,
  frame: getSkeletonConfig,
  slider: getSkeletonConfig,
  tree: getSkeletonConfig,
  ticket: getSkeletonConfig,
  ticketinfo: getSkeletonConfig,
  scroller: getSkeletonConfig,
  texteditor: getSkeletonConfig,
  code: getSkeletonConfig,
};
